import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import HeaderLayout from "../HeaderLayout";

const AppLayout = () => {
  const [isDisplayMobileMenu, setDisplayMobileMenu] = useState(true);
  
  const location = useLocation();

  useEffect(() => {
    setDisplayMobileMenu(!!(location.pathname?.indexOf("booking") !== -1));
  }, [location.pathname]);

  return (
    <>
      <div className={isDisplayMobileMenu ? "main-content" : "main-content mobile-menu"}>
        <HeaderLayout />
        <Outlet />
      </div>
    </>
  );
};

export default AppLayout;
